$(document).ready(function (){
  
/* collection slider producut add to cart start */
$('.product-collection__content-box').on('click',' .addtocart',function(e){
    e.preventDefault();
    var variant_id = $(this).closest('.product-collection__content-box').data('id');
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { id: variant_id, quantity: 1 }
    }).done(function(item) {
      $.get( "/cart?view=mini", function( data ) {
        $('#crt').html(data);
        $('.drawer').addClass("active");
        $('body').addClass("overflow-hidden");
      });
      $.getJSON('/cart.js', function(cart){
      $('body').find('.cart-icon-count').text(cart.item_count);
      });
      // document.dispatchEvent(new Event('cart:updated'));
    });
});
/* collection slider producut add to cart end */

/* tab content section */
$('.ingredient__text').on('click',' .js-tab-content-badge-btn',function(e){
    $(this).parents('.js-ingredient-box-contant').find('.js-ingredient-box-hide').toggleClass("box-contant-active");
    if ($(this).text() == "+ More") {
      $(this).text("- less")
    } else {
      $(this).text("+ More")
    };
  });
  // studie-dropdown 
  $('.studie-dropdown__btn').click(function () {
    $(this).parents('.studie-dropdown').find('.studie-dropdown__text').slideToggle();
    $(this).parents('.studie-dropdown').find('.studie-dropdown__btn span').toggleClass("rotate");
  });
 /* tab content end */




 $(".add_product").click(function(e) {
  e.preventDefault();
  var variant_id = $(this).attr("data-var-id");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        id:variant_id,
        quantity: 1
      },
    }).done(function(data) {
      // document.dispatchEvent(new Event('cart:updated'));
      $.get( "/cart?view=mini", function( data ) {
        $('#crt').html(data);
        $('.drawer').addClass("active");
        $('body').addClass("overflow-hidden");
      });
      $.getJSON('/cart.js', function(cart){
      $('body').find('.cart-icon-count').text(cart.item_count);
      });
  });
});

  $(window).on('scroll', function () {
    var window_top = $(window).scrollTop();
 

    if (window_top > 0) {
        $(".top-announcement").addClass("fixed");
        $(".top-header").addClass("fixed-header");
    } else {
        $(".top-announcement").removeClass("fixed");
        $(".top-header").removeClass("fixed-header");
    }
  });

  // upgrade one-time to subscription in cart-drawer

  $(document).on('click', '.drawer-main-item__desc-option button.upgrade-subs', function(e) {
    e.preventDefault();
    let variantID = Number($(this).attr('data-id'));
    let variantQty = Number($(this).attr('data-current-quantity'));
    let variantSellingID = Number($(this).attr('data-selling-plan-id'));

    //console.log('variantID', variantID, 'variantQty', variantQty, 'variantSellingID', variantSellingID);
    changeSubscription(variantID, variantQty, variantSellingID);
  });

  $(document).on('change', 'select[name="subscription-type"]', function() {
    $(this).find('option').removeClass('selected-option');
    $(this).find('option:selected').addClass('selected-option');

    let sellingPlanID = $(this).find('option:selected').attr('data-selling-id');
    let itemID = $(this).find('option:selected').attr('data-item-id');
    let itemQty = $(this).find('option:selected').attr('data-item-qty');

    changeSubscription(itemID, itemQty, sellingPlanID);
  });

  function changeSubscription(id,qty,selling_id) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        'id': id,
        'quantity': qty,
        'selling_plan': selling_id,
      },
      dataType: 'json',
      success: function (data) {
        addToCartAndOpenDrawer();
        console.log('changed');
      }
    });
  }

  function updateProgressBar(cartTotal) {
    const cartDrawer = document.querySelector('cart-drawer-items');
    if (!cartDrawer) return;
    const maxThreshold = Number(document.querySelector('cart-drawer-items').getAttribute('data-free-shipping')) / 100;
    const progressBar = document.querySelector('.drawer__header-progress-inner');
    let bundleProgressBar = document.querySelector('.progress-bundle__bar-inner');

    let percentage = (cartTotal / maxThreshold) * 100;
    percentage = Math.min(percentage, 100);

    progressBar.style.width = `${percentage}%`;

    let total = 0;
document.querySelectorAll('.bundle-new-flavors__quantity input').forEach(function(input) {
  let quantity = Number(input.value);
  total += quantity;
});

    if (total == 0) {
      if (bundleProgressBar) {
        bundleProgressBar.style.width = `${percentage}%`;
      }
    }
  }

  (function () {
    const originalFetch = window.fetch;
    let isFetchingCart = false; // Flag to prevent multiple calls

    window.fetch = async function (url, options) {
        const response = await originalFetch(url, options);

        if (url.includes('/cart')) {
            if (!isFetchingCart) {
                isFetchingCart = true;
                document.dispatchEvent(new Event('cart:updated'));

                setTimeout(() => {
                    isFetchingCart = false; // Reset flag after delay
                }, 500); // Adjust delay if needed
            }
        }

        return response;
    };
})();

function rewardText() {
  let subscriptionSaving = Number(document.querySelector('p[title="reward-text"]')?.getAttribute('data-save'));
  let rewardTextElement = document.querySelector('p[title="reward-text"]');

  if (subscriptionSaving > 0) {
    if (rewardTextElement) {
      //rewardTextElement.style.display = 'block';

      let totalFreeSaving = document.querySelector('p[title="reward-text"]').getAttribute('data-total-save');
      document.querySelector('p[title="reward-text"] span').innerHTML = totalFreeSaving;
    }
  }
}

document.addEventListener('cart:updated', async () => {
    try {
      setTimeout(async () => {        
        const response = await fetch('/cart.js');
         if (!response.ok) return; 
        const cart = await response.json();
        // console.log('response--', cart, response);

        const cartDrawer = document.querySelector('cart-drawer-items');
        if (!cartDrawer) return;

        $('body').find('.cart-icon-count').text(cart.item_count);
        let cartTotal = cart.total_price / 100;
        // console.log('cartTotal----', cartTotal, response);
        let cartItemCount = cart.item_count;
        let freeShippingPrice = Number(document.querySelector('cart-drawer-items').getAttribute('data-free-shipping'));
        // let diffPrice = freeShippingPrice - cart.total_price;
        let diffPrice = Math.max(0, freeShippingPrice - cart.total_price);
        let formatMoney = Shopify.formatMoney(diffPrice);

        let bundlePageRemainPrice = document.querySelector('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left span');
        let bundlePageFreeShipMsg = document.querySelector('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left');


        // mobile
        let bundlePageRemainPriceMob = document.querySelector('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left span');
        let bundlePageFreeShipMsgMob = document.querySelector('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left');

        let rewardTextEle = document.querySelector('p[title="reward-text"]');

        let bundleQuantityTotal = 0;
        document.querySelectorAll('.bundle-new-flavors__quantity input').forEach(function(input) {
          let quantity = Number(input.value);
          bundleQuantityTotal += quantity;
        });

        if (cart.total_price >= freeShippingPrice) {

          if (bundleQuantityTotal == 0) {
            if (bundlePageFreeShipMsg) {
              $('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left').html("Congrats! you've unlocked free shipping.");
            }

            if (bundlePageFreeShipMsgMob) {
              bundlePageFreeShipMsgMob.innerHTML = "Congrats! you've unlocked free shipping.";
            }
          }

          document.querySelector('p[title="free-shipping"]').textContent = "Nice! You've earned FREE shipping!";
          rewardText();
        } else {

          if (bundleQuantityTotal == 0) {
            if (bundlePageRemainPrice) {
              bundlePageRemainPrice.textContent = formatMoney;
            }

            if (bundlePageRemainPriceMob) {
              bundlePageRemainPriceMob.textContent = formatMoney;
            }

            if (bundlePageFreeShipMsg) {
              bundlePageFreeShipMsg.innerHTML = `You're <span>${formatMoney}</span> away from Free Shipping.`;
            }

            if (bundlePageFreeShipMsgMob) {
              bundlePageFreeShipMsgMob.innerHTML = `You're <span>${formatMoney}</span> away from Free Shipping.`;
            }
          }

          document.querySelector('.drawer__header-progress-text span.remaining-price').textContent = formatMoney;
        }
        
        document.querySelector('.top-header__icons .cart-icon .cart-icon-count').textContent = cartItemCount;
        updateProgressBar(cartTotal);
        
      }, 100);
    } catch (error) {
        console.error('Error fetching cart total:', error);
    }
});

document.addEventListener('cart:refresh', () => {
  document.dispatchEvent(new Event('cart:updated'));
});

document.addEventListener('shopify:cart:change', () => {
  document.dispatchEvent(new Event('cart:updated'));
});

// on load everything for cart
// var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
//   .then(response => response.json())
//   .then(cart => { 
//         const cartDrawer = document.querySelector('cart-drawer-items');
//         if (!cartDrawer) return;
//         let cartTotal = cart.total_price / 100;
//         let cartItemCount = cart.item_count;
//         let freeShippingPrice = Number(document.querySelector('cart-drawer-items').getAttribute('data-free-shipping'));
//         let diffPrice = freeShippingPrice - cart.total_price;
//         let formatMoney = Shopify.formatMoney(diffPrice);

//         let bundlePageRemainPrice = document.querySelector('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left span');
//         let bundlePageFreeShipMsg = document.querySelector('.progress-bundle-wrapper__heading .progress-bundle-wrapper__heading-left');

//         // mobile
//         let bundlePageRemainPriceMob = document.querySelector('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left span');
//         let bundlePageFreeShipMsgMob = document.querySelector('.progress-bundle-wrapper__heading-mob .progress-bundle-wrapper__heading-left');

//         let rewardTextEle = document.querySelector('p[title="reward-text"]');

//         let bundleQuantityTotal = 0;
//         document.querySelectorAll('.bundle-new-flavors__quantity input').forEach(function(input) {
//           let quantity = Number(input.value);
//           bundleQuantityTotal += quantity;
//         });

//         if (diffPrice <= 0) {

//           if (bundleQuantityTotal == 0) {
//             if (bundlePageFreeShipMsg) {
//               bundlePageFreeShipMsg.textContent = "Congrats! you've unlocked free shipping.";
//             }
//           }
          
//           document.querySelector('p[title="free-shipping"]').textContent = "Nice! You've earned FREE shipping!";
//           let totalFreeSaving = document.querySelector('p[title="reward-text"]').getAttribute('data-total-save');

//           //document.querySelector('p[title="reward-text"]').style.display = 'block';
//           document.querySelector('p[title="reward-text"] span').innerHTML = totalFreeSaving;
//           rewardText();
//         } else {

//           if (bundleQuantityTotal == 0) {
//             if (bundlePageRemainPrice) {
//               bundlePageRemainPrice.textContent = formatMoney;
//             }

//             if (bundlePageRemainPriceMob) {
//               bundlePageRemainPriceMob.textContent = formatMoney;
//             }

//             if (bundlePageFreeShipMsg) {
//               bundlePageFreeShipMsg.innerHTML = `You're <span>${formatMoney}</span> away from Free Shipping.`;
//             }

//             if (bundlePageFreeShipMsgMob) {
//               bundlePageFreeShipMsgMob.innerHTML = `You're <span>${formatMoney}</span> away from Free Shipping.`;
//             }
//           }

//           document.querySelector('.drawer__header-progress-text span.remaining-price').textContent = formatMoney;
//         }
        
//         document.querySelector('.top-header__icons .cart-icon .cart-icon-count').textContent = cartItemCount;
//         updateProgressBar(cartTotal);
//    });


});

document.querySelector('.tab-detail__text').querySelectorAll('p').forEach(p => {
  if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.trim() === '') {
    p.style.display = 'none';
  }
});

function handleDropdown() {
  const elements = document.querySelectorAll('.sub-link-dopdown');

  elements.forEach(el => {
    if (window.innerWidth <= 767) {
      el.style.display = 'none';
    } else {
      el.style.removeProperty('display');
    }
  });
}

handleDropdown();
window.addEventListener('resize', handleDropdown);